<template>
  <p class="non-message">
    {{ phrase }}
  </p>
</template>

<script>
export default {
  name: "FacePhraseForIndexPage",

  props: {
    phrase: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.non-message {
  text-align: center;
  color: #777777;
  font-weight: bold;
  padding-top: 50px;
}
</style>
